<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- ダウンロードボタン -->
        <v-btn
          v-if="!readOnly"
          class="mx-2"
          color="primary"
          @click="handleDownload"
        >
          ダウンロード
        </v-btn>
        <!-- 編集ダイアログ -->
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!readOnly"
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              color="primary"
            >
              「新規登録」はこのボタンを押してください
            </v-btn>
          </template>
          <v-form ref="form" v-model="valid">
            <v-card>
              <v-card-title class="pb-0">
                <span class="headline">{{
                  $formTitle("要配慮者施設マスタ", readOnly, isNewEditedItem)
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <p class="red--text mb-0">※：必須項目です</p>
                  <v-row>
                    <v-col cols="3">
                      <!-- 避難元先種別 -->
                      <v-text-field
                        v-if="!(readOnly || isNewEditedItem)"
                        :value="
                          $facility.evaLocationTypes.find(
                            elem => elem.value === editedItem.eva_location_type
                          ).text
                        "
                        label="避難元先種別 ※"
                        readonly
                      ></v-text-field>
                      <v-select
                        v-else
                        :items="$facility.evaLocationTypes"
                        v-model="editedItem.eva_location_type"
                        label="避難元先種別 ※"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="readOnly ? [] : [rules.required()]"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <!-- 施設名 -->
                      <v-text-field
                        v-model="editedItem.fa_name"
                        label="施設名 ※"
                        :rules="readOnly ? [] : [rules.required()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 40)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <!-- 施設名（カナ） -->
                      <v-text-field
                        v-model="editedItem.fa_name_kana"
                        label="施設名（カナ） ※"
                        :rules="
                          readOnly ? [] : [rules.required(), rules.kana()]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 60)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <!-- 施設種別 -->
                      <v-text-field
                        v-if="!(readOnly || isNewEditedItem)"
                        :value="
                          $facility.facilityTypes.find(
                            elem => elem.value === editedItem.vulner_ppl_fa_type
                          ).text
                        "
                        label="施設種別 ※"
                        readonly
                      ></v-text-field>
                      <v-select
                        v-else
                        :items="$facility.facilityTypes"
                        v-model="editedItem.vulner_ppl_fa_type"
                        label="施設種別 ※"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="readOnly ? [] : [rules.required()]"
                        @change="editedItem.fa_details_type = ''"
                      >
                      </v-select>
                    </v-col>
                    <v-col
                      v-if="
                        editedItem.vulner_ppl_fa_type === '1' ||
                          editedItem.vulner_ppl_fa_type === '3'
                      "
                      cols="3"
                    >
                      <!-- 施設詳細種別 -->
                      <v-select
                        :items="faDetailsTypesForEdit"
                        v-model="editedItem.fa_details_type"
                        label="施設詳細種別 ※"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="readOnly ? [] : [rules.required()]"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <!-- 施設住所 -->
                      <v-text-field
                        :value="editedItem.fa_address"
                        @input="editedItem.fa_address = $event ? $event : ''"
                        label="施設住所"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 40)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="!readOnly" cols="12">
                      <p class="black--text">
                        緯度・経度は、DEG形式(10進表記)で入力します。小数部6桁まで入力可能です。<br />
                        <span>緯度の記入例：31.560195</span
                        ><span class="pl-8">経度の記入例：130.557964</span>
                      </p>
                    </v-col>
                    <v-col cols="3">
                      <!-- 緯度 -->
                      <v-text-field
                        v-model="editedItem.latitude"
                        :value="editedItem.latitude"
                        @input="editedItem.latitude = $event ? $event : ''"
                        label="緯度"
                        :rules="
                          readOnly
                            ? []
                            : [
                                rules.numeric(false, true),
                                rules.decimal(2, 6),
                                rules.range(0, 90)
                              ]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 10)"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <!-- 経度 -->
                      <v-text-field
                        v-model="editedItem.longitude"
                        :value="editedItem.longitude"
                        @input="editedItem.longitude = $event ? $event : ''"
                        label="経度"
                        :rules="
                          readOnly
                            ? []
                            : [
                                rules.numeric(false, true),
                                rules.decimal(3, 6),
                                rules.range(0, 180)
                              ]
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 11)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <!-- 原発からの距離 -->
                      <v-text-field
                        v-model="editedItem.distance_from_npp"
                        :value="editedItem.distance_from_npp"
                        :placeholder="config.PLACEHOLDER_SP"
                        label="原発からの直線距離 (km)"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <!-- 原発からの方角 -->
                      <v-text-field
                        v-model="editedItem.direction_from_npp"
                        :value="editedItem.direction_from_npp"
                        :placeholder="config.PLACEHOLDER_SP"
                        label="原発からの方角"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <!-- シェルター有無 -->
                      <v-radio-group
                        v-model="editedItem.shelter_exist"
                        v-bind="formControlProps()"
                        row
                      >
                        <template #label>
                          <div class="caption">シェルター有無</div>
                        </template>
                        <v-radio
                          v-for="shelterExist in $facility.shelterExists"
                          :key="shelterExist.value"
                          :label="shelterExist.text"
                          :value="shelterExist.value"
                          class="mr-3"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <!-- 管理区域 -->
                      <v-select
                        :items="$facility.controlledAreas"
                        v-model="editedItem.controlled_area"
                        label="管理区域 ※"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="readOnly ? [] : [rules.required()]"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <!-- 最大収容人数 -->
                      <v-text-field
                        v-model="editedItem.max_capacity"
                        label="最大収容人数 ※"
                        suffix="人"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 4)"
                        :rules="
                          readOnly ? [] : [rules.required(), rules.numeric()]
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col v-if="editedItem.eva_location_type === '2'" cols="3">
                      <!-- 受入可能者数 -->
                      <v-text-field
                        v-model="editedItem.acceptable_capacity"
                        label="受入可能者数"
                        suffix="人"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 4)"
                        :rules="readOnly ? [] : [rules.numeric()]"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <!-- 市町村 -->
                      <v-select
                        :items="municipalities"
                        v-model="editedItem.municip_code"
                        label="市町村 ※"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="readOnly ? [] : [rules.required()]"
                        @change="editedItem.area_code = ''"
                      ></v-select>
                    </v-col>
                    <v-col cols="3">
                      <!-- 地域（地区） -->
                      <v-select
                        v-model="editedItem.area_code"
                        :items="areasForEdit"
                        :label="
                          editedItem.eva_location_type === '2'
                            ? '地域（地区）'
                            : '地域（地区） ※'
                        "
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="
                          readOnly
                            ? []
                            : editedItem.eva_location_type === '2'
                            ? []
                            : [rules.required(), rules.dpndAreaCode()]
                        "
                      ></v-select>
                    </v-col>
                    <v-col cols="3">
                      <!-- 組織 -->
                      <v-autocomplete
                        v-model="editedItem.organize_id"
                        :items="organizations"
                        item-text="organize_name"
                        item-value="organize_id"
                        label="組織 ※"
                        v-bind="formControlProps(config.PLACEHOLDER_SELECT)"
                        :rules="
                          readOnly
                            ? []
                            : [rules.required(), rules.dpndOrganizeId()]
                        "
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <!-- 避難元医療機関等施設 -->
                  <!-- <v-row v-if="isEditable('shelter_info')"> -->
                  <v-row v-if="editedItem.eva_location_type === '2'">
                    <v-col cols="12">
                      <vul-facility-info
                        :vul-facility-info="editedItem.vul_facility_info"
                        :municipalities="municipalities"
                        :facilities="facilities"
                        :read-only="this.readOnly"
                        :fa-id="editedItem.fa_id"
                        :edited-vul-facility-info.sync="
                          editedItem.edited_vul_facility_info
                        "
                        ref="vulFacilityInfo"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <!-- 施設管理者/責任者 -->
                      <v-text-field
                        :value="editedItem.fa_respons_person"
                        @input="
                          editedItem.fa_respons_person = $event ? $event : ''
                        "
                        label="施設管理者/責任者"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 40)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <!-- 連絡先電話番号 -->
                      <v-text-field
                        :value="editedItem.fa_phone"
                        @input="editedItem.fa_phone = $event ? $event : ''"
                        label="連絡先電話番号"
                        :rules="readOnly ? [] : [rules.phone()]"
                        v-bind="
                          formControlProps(
                            config.PLACEHOLDER_INPUT,
                            20,
                            config.HINT_TEL_AND_EXTENSION_WITH_HYPHEN
                          )
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <!-- 連絡先FAX -->
                      <v-text-field
                        :value="editedItem.fa_fax"
                        @input="editedItem.fa_fax = $event ? $event : ''"
                        label="連絡先FAX"
                        :rules="readOnly ? [] : [rules.phone()]"
                        v-bind="
                          formControlProps(
                            config.PLACEHOLDER_INPUT,
                            20,
                            config.HINT_TEL_AND_EXTENSION_WITH_HYPHEN
                          )
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <!-- 連絡先メールアドレス -->
                      <v-text-field
                        :value="editedItem.fa_mail_address"
                        @input="
                          editedItem.fa_mail_address = $event ? $event : ''
                        "
                        label="連絡先メールアドレス"
                        :rules="readOnly ? [] : [rules.mail()]"
                        v-bind="formControlProps(config.PLACEHOLDER_INPUT, 100)"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <!-- DPND施設ID -->
                      <v-text-field
                        v-model="editedItem.dpnd_fa_id"
                        :placeholder="config.PLACEHOLDER_SP"
                        label="DPND施設ID"
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!readOnly"
                  class="mx-2"
                  color="primary"
                  :loading="loading"
                  :disabled="!valid"
                  @click="handleSaveEditDialog"
                >
                  {{ isNewEditedItem ? "登録" : "更新" }}
                </v-btn>
                <v-btn
                  class="mx-2"
                  color="primary"
                  :disabled="loading"
                  @click="handleCloseEditDialog"
                >
                  {{ $cancelButtonText(readOnly) }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0;">
          要配慮者施設マスタは下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="3" md="3">
            <!-- 検索項目：市町村 -->
            <v-select
              v-model="searchItem.municipality"
              :items="municipalitiesAddAll"
              label="市町村"
              :placeholder="config.PLACEHOLDER_SELECT"
              outlined
              hide-details
            >
            </v-select>
          </v-col>
          <v-col cols="3" md="3">
            <!-- 検索項目：地域 -->
            <v-select
              v-model="searchItem.area"
              :items="areas"
              label="地域（地区）"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <!-- 検索項目：避難元先種別 -->
            <v-select
              v-model="searchItem.evaLocationType"
              :items="$facility.evaLocationTypes"
              label="避難元先種別"
              :placeholder="config.PLACEHOLDER_SELECT"
              clearable
              outlined
              hide-details
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="6">
            <!-- 未設定項目アラート -->
            <p v-if="!readOnly && hasUnsetItem" class="red--text text-body-2">
              必須項目未設定のマスタが存在します。<br />
              「未設定項目がある施設のみ表示」にチェックを入れて表示された明細を編集してください。
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p class="grey--text">
              部分一致で検索することができます。<br />
              検索は施設名、施設名（カナ）、施設住所、施設管理者／責任者の項目が対象です。<br />
              スペースを挟み、複数の語句で検索することはできません。<br />
            </p>
          </v-col>
          <v-col cols="12">
            <!-- 検索項目：フリーテキスト -->
            <v-text-field
              v-model="searchItem.freeText"
              label="フリーテキスト"
              placeholder="施設名、施設名（カナ）、施設住所、施設管理者/責任者から検索"
              clearable
              append-icon="mdi-magnify"
              outlined
              hide-details
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- 検索項目：未設定項目あり -->
            <v-checkbox
              v-model="searchItem.showsUnsetOnly"
              label="未設定項目がある施設のみ表示"
              dense
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
        <!-- 凡例 -->
        <v-row
          v-if="showsDataTable"
          class="ml-4 mt-4"
          style="font-size: small"
          no-gutters
        >
          <v-col cols="12">【凡例】</v-col>
          <v-col cols="12" class="d-flex">
            <div class="pr-4">緯度、経度、地域、組織</div>
            <div>
              ○: 登録あり<br />
              －: 登録なし
            </div>
          </v-col>
        </v-row>
        <!-- 一覧表 -->
        <top-operation-data-table
          ref="table"
          v-if="showsDataTable"
          :headers="headers"
          :items="filteredItems"
          class="mt-n10"
          locale="ja-jp"
          item-key="fa_id"
          sort-by="fa_name_kana"
          rowCount="-1"
          must-sort
        >
          <template v-slot:[`item.fa_name`]="{ item }">
            {{ $facility.facilityName(item) }}
          </template>
          <template v-slot:[`item.fa_name_kana`]="{ item }">
            {{ $facility.facilityNameKana(item) }}
          </template>
          <template v-slot:[`item.vulner_ppl_fa_type`]="{ item }">
            {{ $facility.facilityTypeName(item) }}
          </template>
          <template v-slot:[`item.shelter_exist`]="{ item }">
            {{ $facility.shelterExistName(item) }}
          </template>
          <template v-slot:[`item.controlled_area`]="{ item }">
            {{ $facility.controlledAreaName(item) }}
          </template>
          <template v-slot:[`item.vul_facility_places`]="{ item }">
            <div v-html="getVulFacilityPlaceNames(item)"></div>
          </template>
          <template v-slot:[`item.latitude`]="{ item }">
            {{ unsetTargets.latitude.criteria(item.latitude) ? "－" : "○" }}
          </template>
          <template v-slot:[`item.longitude`]="{ item }">
            {{ unsetTargets.longitude.criteria(item.longitude) ? "－" : "○" }}
          </template>
          <template v-slot:[`item.area_code`]="{ item }">
            {{ unsetTargets.area_code.criteria(item.area_code) ? "－" : "○" }}
          </template>
          <template v-slot:[`item.organize_id`]="{ item }">
            {{
              unsetTargets.organize_id.criteria(item.organize_id) ? "－" : "○"
            }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <template v-if="readOnly">
              <v-btn
                small
                class="mx-2"
                color="primary"
                @click="handleView(item)"
                >参照</v-btn
              >
            </template>
            <template v-else>
              <v-btn
                small
                class="mx-2"
                color="primary"
                @click="handleEdit(item)"
                >編集</v-btn
              >
              <v-btn
                small
                class="mx-2"
                color="primary"
                @click="handleDelete(item)"
                >削除</v-btn
              >
            </template>
          </template>
        </top-operation-data-table>
      </v-container>
    </v-sheet>
    <!-- ダイアログ -->
    <confirm-dialog ref="confirmDialog" />
    <!-- オーバーレイ -->
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import ConfirmDialog from "@/components/ConfirmDialog";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import config from "@/js/const";
import Facility from "@/plugins/facility";
import FormUtils from "@/plugins/form-utils";
import Validation from "@/plugins/validation";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
import { ScreenId } from "@/js/value-objects/screen-id";
import messageUtils from "@/mixins/message-utils";
import { fileDownload } from "@/js/utils";
import { arrayCount } from "@/js/utils";

Vue.use(Facility, Validation, FormUtils);

const organizeMstRepository = RepositoryFactory.get("organizeMst");
const vulFacilityRepository = RepositoryFactory.get("vulFacility");

// DPND連携で未設定として扱う地域コード
const DEFAULT_DPND_AREA_CODE = "00000000";
// DPND連携で未設定として扱う組織ID
const DEFAULT_DPND_ORGANIZE_ID = "OIDPND";
// 原発からの距離計算で使用する地球の半径
const EARTH_RADIUS = 6371;
// 原発からの方角計算で使用する方角
const directions = [
  "北",
  "北北東",
  "北東",
  "東北東",
  "東",
  "東南東",
  "南東",
  "南南東",
  "南",
  "南南西",
  "南西",
  "西南西",
  "西",
  "西北西",
  "北西",
  "北北西"
];

/**
 * バリデーションルールを作成する。
 * @function
 * @returns {Object} バリデーションルール
 */
const getRules = () => ({
  /**
   * 必須チェックルールを作成する
   * @function
   * @returns 必須チェックルール
   */
  required: () => v => !!v || "必須項目です。",

  /**
   * DPND地域コードの初期値チェックルールを作成する。
   */
  dpndAreaCode: () => v => v !== DEFAULT_DPND_AREA_CODE || "必須項目です。",

  /**
   * DPND組織IDの初期値チェックルールを作成する。
   */
  dpndOrganizeId: () => v => v !== DEFAULT_DPND_ORGANIZE_ID || "必須項目です。",

  /**
   * 数値チェックルールを作成する
   * @function
   * @param {boolean} [acceptNegative=false] 負数(マイナス記号)の入力を許容するかどうか
   * @param {booealn} [acceptFloat=false] 小数の入力を許容するかどうか
   * @returns 数値チェックルール
   */
  numeric: (
    acceptNegative = false,
    acceptFloat = false,
    pattern = new RegExp(
      `^${acceptNegative ? "-?" : ""}\\d+${acceptFloat ? "(\\.\\d+)?" : ""}$`
    )
  ) => v => !v || pattern.test(v) || "数値で入力してください",

  /**
   * 小数点数の整数部と小数部の桁数チェックルールを作成する
   * @function
   * @param {number} digit 整数部の桁数
   * @param {number} scale 小数部の桁数
   * @returns 小数点数の桁数チェックルール
   */
  decimal: (
    digit,
    scale,
    pattern = new RegExp(`^-?\\d{1,${digit}}(\\.\\d{1,${scale}})?$`)
  ) => v =>
    !v ||
    pattern.test(v) ||
    `整数部${digit}桁以内、小数部${scale}桁以内で入力してください。`,

  /**
   * 数値範囲チェックルールを作成する
   * @function
   * @param {number} min 最小値(以上)
   * @param {number} max 最大値(以下)
   * @returns 数値範囲チェックルール
   */
  range: (min, max) => v => {
    if (!v) {
      return true;
    }

    const value = Number(v);
    if (value >= min && value <= max) {
      return true;
    }

    return `既定の範囲内(${min}~${max})数値を入力してください。`;
  },

  /**
   * 全角カナ入力チェックルールを作成する
   * @function
   * @returns 全角カナ入力チェックルール
   */
  kana: () => v =>
    !v ||
    /^[ァ-ヶ\u3000 －―‐ー「」（）・]+$/.test(v) ||
    "全角カナ文字を入力してください。",

  /**
   * メールアドレスの入力チェックルールを作成する
   * @function
   * @returns メールアドレス入力チェックルール
   */
  mail: () => v =>
    !v ||
    /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{2,}$/.test(
      v
    ) ||
    "「@(アットマーク)」を含んだ正しいメールアドレスの形式で入力してください。",

  /**
   * 電話番号の入力チェックルールを作成する
   * @function
   * @returns 電話番号の入力チェックルール
   */
  phone: () => v =>
    /^[\d()-]*$/.test(v) || "正しい電話(FAX)番号の形式で入力してください。"
});

/**
 * 一覧表のヘッダーを作成する。
 */
const getHeaders = () => [
  {
    text: "施設ID",
    align: " d-none",
    value: "fa_id"
  },
  {
    text: "施設名",
    value: "fa_name"
  },
  {
    text: "施設名（カナ）",
    align: "start",
    value: "fa_name_kana"
  },
  {
    text: "施設種別",
    value: "vulner_ppl_fa_type"
  },
  {
    text: "施設詳細種別",
    value: "fa_details_type_val"
  },
  {
    text: "避難元先種別",
    value: "eva_location_type_val"
  },
  {
    text: "シェルター",
    value: "shelter_exist"
  },
  {
    text: "管理区域",
    value: "controlled_area"
  },
  {
    text: "避難元施設",
    value: "vul_facility_places",
    sortable: false
  },
  {
    text: "緯度",
    value: "latitude",
    // 昇順時、○－の順で並び替え
    sort: (a, b) => (a ? 0 : 1) - (b ? 0 : 1)
  },
  {
    text: "経度",
    value: "longitude",
    // 昇順時、○－の順で並び替え
    sort: (a, b) => (a ? 0 : 1) - (b ? 0 : 1)
  },
  {
    text: "地域",
    value: "area_code",
    // 昇順時、○－の順で並び替え
    sort: (a, b) => (a ? 0 : 1) - (b ? 0 : 1)
  },
  {
    text: "組織",
    value: "organize_id",
    // 昇順時、○－の順で並び替え
    sort: (a, b) => (a ? 0 : 1) - (b ? 0 : 1)
  },
  {
    text: "操作",
    value: "actions",
    sortable: false,
    width: 180
  }
];

/**
 * 未設定判定対象の項目名と判定条件を作成する。
 * @function
 * @returns 未設定判定対象の項目名と判定条件
 */
const getUnsetTargets = () => {
  const isFalsy = value => !value;
  const isFalsyOrEqualsTo = target => value =>
    isFalsy(value) || target === value;

  const isFalsyOrDefaultAreaCode = isFalsyOrEqualsTo(DEFAULT_DPND_AREA_CODE);
  const isFalsyOrDefaultOrganizeId = isFalsyOrEqualsTo(
    DEFAULT_DPND_ORGANIZE_ID
  );

  return [
    { name: "fa_name", criteria: isFalsy },
    { name: "fa_name_kana", criteria: isFalsy },
    { name: "latitude", criteria: isFalsy },
    { name: "longitude", criteria: isFalsy },
    { name: "distance_from_npp", criteria: isFalsy },
    { name: "direction_from_npp", criteria: isFalsy },
    { name: "vulner_ppl_fa_type", criteria: isFalsy },
    { name: "fa_details_type", criteria: isFalsy },
    { name: "eva_location_type", criteria: isFalsy },
    { name: "controlled_area", criteria: isFalsy },
    { name: "max_capacity", criteria: isFalsy },
    { name: "acceptable_capacity", criteria: isFalsy },
    { name: "municip_code", criteria: isFalsy },
    { name: "area_code", criteria: isFalsyOrDefaultAreaCode },
    { name: "organize_id", criteria: isFalsyOrDefaultOrganizeId }
  ];
};

/**
 * 組織リストを取得する。
 * @param {string} screenId 画面ID
 * @returns {object[]} 組織リスト
 */
const fetchOrganizations = async screenId => {
  return (await organizeMstRepository.list(screenId)).data.results;
};

/**
 * リストボックス用要配慮者施設マスタを取得する。(避難元全件)
 * @param {string} screenId 画面ID
 * @returns {object[]} 要配慮者施設リスト
 */
const fetchVulFacilitiesList = async screenId => {
  return (await vulFacilityRepository.listbox(screenId)).data.results;
};

/**
 * 要配慮者施設マスタを取得する。
 * @param {string} screenId 画面ID
 * @param {string} [municipCode=""] 市町村コード(省略時は全件)
 * @returns {object[]} 要配慮者施設リスト
 */
const fetchVulFacilities = async (screenId, municipCode = "") => {
  return (await vulFacilityRepository.list(screenId, municipCode)).data.results;
};

/**
 * CSVの行を結合する関数を作成する。
 * @function
 * @param {string} [separator=\n] 行の区切り文字
 * @returns 区切り文字で行を結合する関数
 */
const getCSVRowJoiner = (separator = "\n") => lines =>
  `${lines.join(separator)}${separator}`;

/**
 * CSVの列を結合する関数を作成する。
 * @function
 * @param {string} [separator=,] 列の区切り文字
 * @param {string} [quote="] 値を囲う文字
 * @returns 区切り文字で列を結合する関数
 */
const getCSVColJoiner = (separator = ",", quote = '"') => fields =>
  fields.map(field => quote + field + quote).join(separator);

/**
 * 2次元配列をCSVテキストに変換する関数を作成する。
 * @function
 * @param {rowJoiner} 行結合関数
 * @param {colJoiner} 列結合関数
 */
const getCSVFormatter = (
  rowJoiner = getCSVRowJoiner(),
  colJoiner = getCSVColJoiner(),
  bom = "\ufeff"
) => records => bom + rowJoiner(records.map(colJoiner));

/**
 * 空の避難元施設情報を1つ保持する配列を作成する。
 * （CSVダウンロードの前処理）
 * @function
 * @returns 空の避難元施設情報
 */
const createEmptyVulFacilityInfoForCSV = () => [
  {
    vul_destination_fa_id: "",
    vul_origin_fa_id: "",
    vul_origin_fa_name: "",
    vul_origin_municip_code: "",
    vul_origin_municip_name: ""
  }
];

/**
 * 避難元施設情報が存在しない場合、空の避難元施設情報を追加する。
 * （CSVダウンロードの前処理）
 * @function
 */
const addEmptyVulFacilityInfoIfNeeded = ({
  vul_facility_info = null,
  ...rest
}) => ({
  ...rest,
  vul_facility_info:
    Array.isArray(vul_facility_info) && vul_facility_info.length > 0
      ? vul_facility_info
      : createEmptyVulFacilityInfoForCSV()
});

/**
 * 要配慮者施設情報×避難元施設情報数分のレコードに平坦化する。
 * （CSVダウンロードの前処理）
 * @function
 */
const flatternVulFacilityInfo = ({ vul_facility_info, ...rest }) =>
  vul_facility_info.map(vul_facility_info_elem => ({
    ...rest,
    ...vul_facility_info_elem
  }));

/**
 * CSVのヘッダ名と属性名リスト
 */
const CSV_FIELDS = [
  { name: "施設ID", attr: "fa_id" },
  { name: "施設名", attr: "fa_name" },
  { name: "施設名(カナ)", attr: "fa_name_kana" },
  { name: "施設種別ID", attr: "vulner_ppl_fa_type" },
  { name: "施設種別", attr: "vulner_ppl_fa_type_val" },
  { name: "施設詳細種別ID", attr: "fa_details_type" },
  { name: "施設詳細種別", attr: "fa_details_type_val" },
  { name: "避難元先種別ID", attr: "eva_location_type" },
  { name: "避難元先種別", attr: "eva_location_type_val" },
  { name: "施設住所", attr: "fa_address" },
  { name: "緯度", attr: "latitude" },
  { name: "経度", attr: "longitude" },
  { name: "原発からの距離", attr: "distance_from_npp" },
  { name: "原発からの方角", attr: "direction_from_npp" },
  { name: "原発からの方角（英）", attr: "direction_from_npp_en" },
  { name: "シェルター有無ID", attr: "shelter_exist" },
  { name: "シェルター有無", attr: "shelter_exist_val" },
  { name: "管理区域ID", attr: "controlled_area" },
  { name: "管理区域", attr: "controlled_area_val" },
  { name: "最大収容人数", attr: "max_capacity" },
  { name: "受入可能者数", attr: "acceptable_capacity" },
  { name: "市町村コード", attr: "municip_code" },
  { name: "市町村名", attr: "municip_name" },
  { name: "地域コード", attr: "area_code" },
  { name: "地域(地区)", attr: "area_name" },
  { name: "組織ID", attr: "organize_id" },
  { name: "組織名称", attr: "organize_name" },
  { name: "施設管理者/責任者", attr: "fa_respons_person" },
  { name: "連絡先電話番号", attr: "fa_phone" },
  { name: "連絡先FAX", attr: "fa_fax" },
  { name: "連絡先メールアドレス", attr: "fa_mail_address" },
  { name: "DPND施設ID", attr: "dpnd_fa_id" },
  { name: "避難元市町村コード", attr: "vul_origin_municip_code" },
  { name: "避難元市町村名", attr: "vul_origin_municip_name" },
  { name: "避難元施設ID", attr: "vul_origin_fa_id" },
  { name: "避難元施設名", attr: "vul_origin_fa_name" }
];

/**
 * CSV出力時の並び替え関数
 * 施設名（カナ）の昇順で並び替える。
 *
 * @function
 * @param {object} a 比較対象。APIの戻り値オブジェクト
 * @param {object} b 比較対象。APIの戻り値オブジェクト
 * @returns aの方が小さい場合は -1、大きい場合は 1、その他の場合は 0。
 */
const csvSorter = (a, b) => {
  const keyA = a.fa_name_kana;
  const keyB = b.fa_name_kana;

  if (keyA < keyB) {
    return -1;
  }

  if (keyA > keyB) {
    return 1;
  }

  return 0;
};

/**
 * オブジェクトを配列に変換する関数を作成する。
 * @function
 * @param {string[]} order 配列が対応する属性名リスト
 * @returns オブジェクトを属性名リストにしたがって配列に変換する関数
 */
const toCSVColArray = (order = CSV_FIELDS.map(({ attr }) => attr)) => items =>
  order.map(key => items[key]);

/**
 * タイムスタンプ文字列(YYYYMMDD_HHMM)を作成する。
 * @param {Date} [date=new Date()] 文字列に変換対象の日付。
 * @returns タイムスタンプ文字列
 */
const getTimestamp = (date = new Date()) => {
  const padZero = value => value.toString().padStart(2, "0");

  const dateText = [date.getMonth() + 1, date.getDate()].map(padZero).join("");
  const timeText = [date.getHours(), date.getMinutes()].map(padZero).join("");

  return `${date.getFullYear()}${dateText}_${timeText}`;
};

/**
 * 編集対象（APIのCSV出力用の項目を含まない）項目リスト
 */
const EDITABLE_ATTRIBUTES = [
  "fa_name",
  "fa_name_kana",
  "vulner_ppl_fa_type",
  "fa_details_type",
  "eva_location_type",
  "fa_address",
  "latitude",
  "longitude",
  "distance_from_npp",
  "direction_from_npp",
  "shelter_exist",
  "controlled_area",
  "max_capacity",
  "acceptable_capacity",
  "municip_code",
  "area_code",
  "organize_id",
  "fa_respons_person",
  "fa_phone",
  "fa_fax",
  "fa_mail_address",
  "dpnd_fa_id",
  "vul_facility_info",
  "edited_vul_facility_info"
];

/**
 * 空の編集アイテムを作成する。
 * @returns {object} 編集アイテム
 */
const createEditedItem = () => ({
  fa_name: "",
  fa_name_kana: "",
  vulner_ppl_fa_type: "",
  fa_details_type: "",
  eva_location_type: "",
  fa_address: "",
  latitude: "",
  longitude: "",
  distance_from_npp: "",
  direction_from_npp: "",
  shelter_exist: "0",
  controlled_area: "",
  max_capacity: "",
  acceptable_capacity: "",
  municip_code: "",
  area_code: "",
  organize_id: "",
  fa_respons_person: "",
  fa_phone: "",
  fa_fax: "",
  fa_mail_address: "",
  dpnd_fa_id: "",
  vul_facility_info: [],
  edited_vul_facility_info: createVulFacilityInfo()
});

/**
 * 空の避難所を1つ保持する配列を作成する。
 * @function
 * @returns 空の避難所情報
 */
const createVulFacilityInfo = () => [
  {
    key: 1,
    vul_origin_municip_code: "",
    vul_origin_fa_id: ""
  }
];

/**
 * オブジェクトから編集可能項目のみを抽出する。
 */
const convertEditable = ({ vul_facility_info = null, ...rest }) => {
  const result = {
    // 編集可能項目のみを抽出
    ...Object.fromEntries(EDITABLE_ATTRIBUTES.map(key => [key, rest[key]])),
    // デフォルト値を設定
    vul_facility_info: [],
    edited_vul_facility_info: createVulFacilityInfo()
  };

  // vul_facility_info の設定
  if (Array.isArray(vul_facility_info) && vul_facility_info.length > 0) {
    const filteredInfo = vul_facility_info.map(info => ({
      vul_origin_municip_code: info.vul_origin_municip_code,
      vul_origin_fa_id: info.vul_origin_fa_id
    }));
    result.vul_facility_info = cloneDeep(filteredInfo);
    result.edited_vul_facility_info = cloneDeep(filteredInfo);
  }

  return result;
};

export default {
  mixins: [messageUtils],

  components: {
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    VulFacilityInfo: () => import("@/components/facility/VulFacilityInfo"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },

  data: () => ({
    config: config,
    overlay: false,
    loading: false,
    dialog: false,
    valid: false,
    screenTitle: "",
    screenId: "",
    readOnly: false,
    // 検索項目
    searchItem: {
      // 市町村コード
      municipality: null,
      // 地区コード
      area: null,
      // フリーテキスト
      freeText: null,
      // 未設定項目がある施設のみ表示
      showsUnsetOnly: false
    },
    // 組織リスト
    organizations: [],
    // 要配慮者施設マスタリスト
    items: [],
    // 編集中の要配慮者マスタリストのインデックス(新規の場合は、-1)
    editedIndex: -1,
    // 編集中の要配慮者マスタ
    editedItem: createEditedItem(),
    // 要配慮者施設リスト(リストボックス用)
    facilities: []
  }),

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  computed: {
    /**
     * フォームの検証ルール
     */
    rules() {
      return getRules();
    },

    /**
     * 一覧表のヘッダー
     */
    headers() {
      return getHeaders();
    },

    /**
     * 編集中のアイテムが新規登録かどうかを示す値
     */
    isNewEditedItem() {
      return this.editedIndex === -1;
    },

    /**
     * アイテム毎の未設定項目判定結果
     * unsetItemFlags[n]は、items[n]の判定結果を保持する。
     */
    unsetItemFlags() {
      return this.items.map(item =>
        Object.values(this.unsetTargets).some(({ name, criteria }) =>
          criteria(item[name])
        )
      );
    },

    /**
     * 未設定項目があるかどうかを示す値
     */
    hasUnsetItem() {
      return this.unsetItemFlags.some(flag => flag);
    },

    /**
     * 検索項目によってフィルタしたアイテムリスト
     */
    filteredItems() {
      // 常にTrueを返す関数
      const alwaysTrue = () => true;

      // 地域フィルタ（未指定の場合は常にTrue）
      const areaFilter = area =>
        area ? item => item.area_code === area : alwaysTrue;

      // 避難元先種別フィルタ（未指定の場合は常にTrue）
      const facilityClassFilter = evaLocationType =>
        evaLocationType
          ? item => item.eva_location_type === evaLocationType
          : alwaysTrue;

      // フリーテキストフィルタ（未指定の場合は常にTrue）
      const freeTextFilter = freeText =>
        freeText
          ? item =>
              this.freeTextTargets.some(name => item[name]?.includes(freeText))
          : alwaysTrue;

      // 未設定項目フィルタ（未設定の場合は常にTrue）
      const unsetFilter = showsUnsetOnly =>
        showsUnsetOnly
          ? item => this.unsetItemFlags[this.items.indexOf(item)]
          : alwaysTrue;

      return this.items
        .filter(areaFilter(this.searchItem.area))
        .filter(facilityClassFilter(this.searchItem.evaLocationType))
        .filter(freeTextFilter(this.searchItem.freeText))
        .filter(unsetFilter(this.searchItem.showsUnsetOnly));
    },

    /**
     * 未設定項目の判定対象の属性名と判定関数オブジェクト
     */
    unsetTargets() {
      return Object.fromEntries(
        getUnsetTargets().map(target => [target.name, target])
      );
    },

    /**
     * フリーテキストの検索対象の属性名リスト
     */
    freeTextTargets() {
      return ["fa_name", "fa_name_kana", "fa_address", "fa_respons_person"];
    },

    /**
     * 表を表示するかどうかを示す値
     */
    showsDataTable() {
      return !!this.searchItem.municipality;
    },

    /**
     * 市町村のリスト
     */
    municipalities() {
      const municipalities = this.$store.state.allArea?.municipalities;
      if (municipalities && Array.isArray(municipalities)) {
        return municipalities;
      }

      return [];
    },

    /**
     * 市町村のリスト（一覧取得）
     */
    municipalitiesAddAll() {
      const municipalities = this.$store.state.allArea?.municipalities;
      if (municipalities && Array.isArray(municipalities)) {
        return [{ text: "すべて", value: "all" }, ...municipalities];
      }

      return [];
    },

    /**
     * 地域（地区）のリスト
     */
    areas() {
      const areas = this.$store.state.allArea?.areas;
      if (areas && Array.isArray(areas)) {
        return AllAreaTranslator.toAreasByMunicipality(
          this.$store.state.allArea?.areas ?? [],
          this.searchItem.municipality
        );
      }

      return [];
    },

    /**
     * 編集ダイアログ用の地域（地区）のリスト
     */
    areasForEdit() {
      return AllAreaTranslator.toAreasByMunicipality(
        this.$store.state.allArea?.areas ?? [],
        this.editedItem.municip_code
      );
    },

    /**
     * 編集ダイアログ用の施設詳細種別のリスト（施設種別の選択に応じて表示）
     */
    faDetailsTypesForEdit() {
      return this.toDetailsTypesByFaType(
        this.$facility.faDetailsTypes ?? [],
        this.editedItem.vulner_ppl_fa_type
      );
    },

    /**
     * フォームコントロール用の属性作成関数
     */
    formControlProps: () => {
      return function(
        placeholder = config.PLACEHOLDER_SP,
        counter = null,
        hint = null
      ) {
        const formControlProps = this.$formControlProps(
          this.readOnly,
          counter,
          true,
          hint
        );

        if (this.readOnly) {
          placeholder = config.PLACEHOLDER_SP;
        }

        formControlProps.placeholder = placeholder;
        formControlProps.readonly = formControlProps.disabled;
        delete formControlProps.disabled;

        return formControlProps;
      };
    }
  },

  watch: {
    $route: "initialize",

    /**
     * ダイアログの表示を監視
     */
    dialog(value) {
      if (value) {
        this.openEditDialog();
      }
    },

    /**
     * 検索項目の変更を監視
     */
    searchItem: {
      handler() {
        this.resetPage();
      },
      deep: true
    },

    /**
     * 検索項目の市町村の変更を監視
     */
    "searchItem.municipality": async function() {
      this.overlay = true;
      try {
        this.searchItem.area = "";
        await this.refreshItems();
      } catch (e) {
        this.handleGetError(e);
      } finally {
        this.overlay = false;
      }
    },

    /* 緯度、経度テキストボックスの変更を監視 */
    "editedItem.latitude": function() {
      this.returnDistance();
      this.returnDirection();
    },
    "editedItem.longitude": function() {
      this.returnDistance();
      this.returnDirection();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    /**
     * コンポーネントを初期化する。
     */
    async initialize() {
      this.overlay = true;
      try {
        // 操作権限
        const screen = this.$screenOperationAuthority(
          ScreenId.SF1501,
          ScreenId.SF1502
        );
        this.screenId = screen.screenId;
        this.readOnly = screen.readOnly;
        this.screenTitle = screen.screenTitle;

        // 市町村
        await this.$store.dispatch("allArea/loadAllArea");

        // リストボックス用施設名取得
        this.facilities = await fetchVulFacilitiesList(this.screenId);

        // 組織
        this.organizations = await fetchOrganizations(this.screenId);
      } catch (error) {
        this.handleError(error, this.screenId, "aggregation-menu");
      } finally {
        this.overlay = false;
      }
    },

    /**
     * 選択中の市町村にしたがって、要配慮者施設マスタを取得する。
     */
    async refreshItems() {
      if (!this.searchItem.municipality) {
        this.items = [];
      } else {
        this.items = await fetchVulFacilities(
          this.screenId,
          this.searchItem.municipality
        );
      }
    },

    /**
     * ダウンロードボタンのクリックイベントを処理する。
     */
    async handleDownload() {
      this.overlay = true;
      try {
        const records = (await fetchVulFacilities(this.screenId))
          .map(addEmptyVulFacilityInfoIfNeeded)
          .flatMap(flatternVulFacilityInfo);
        const sorted = [...records].sort(csvSorter);

        const matrix = [
          CSV_FIELDS.map(({ name }) => name),
          ...sorted.map(toCSVColArray())
        ];

        fileDownload(
          new Blob([getCSVFormatter()(matrix)], {
            type: "text/csv"
          }),
          `要配慮者施設マスタ_${getTimestamp()}.csv`
        );
      } finally {
        this.overlay = false;
      }
    },

    /**
     * 参照ボタンのクリックイベントを処理する。
     */
    handleView(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.openEditDialog();
    },

    /**
     * 編集ボタンのクリックイベントを処理する。
     */
    handleEdit(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = convertEditable(item);
      this.openEditDialog();
    },

    /**
     * 削除ボタンのクリックイベントを処理する。
     */
    async handleDelete(item) {
      this.clearMessage();

      const messages = [
        "削除した場合には元に戻せません。本当によろしいですか？"
      ];
      for (let message of messages) {
        if (!(await this.showConfirmDialog("削除", message))) {
          return;
        }
      }

      this.overlay = true;
      try {
        // 要配慮者施設マスタを削除して再取得
        this.handleSuccess(await this.deleteRecord(item));
        await this.refreshItems();
      } catch (error) {
        this.handleUpdateError(error);
      } finally {
        this.overlay = false;
      }
    },

    /**
     * 編集ダイアログの登録または更新ボタンクリックイベントを処理する。
     */
    async handleSaveEditDialog() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (
        this.$refs.vulFacilityInfo &&
        !this.$refs.vulFacilityInfo.validate()
      ) {
        return;
      }

      this.clearMessage();
      this.overlay = true;
      this.loading = true;
      try {
        // 要配慮者施設マスタを登録または更新して再取得
        if (this.isNewEditedItem) {
          this.handleSuccess(await this.createRecord());
        } else {
          this.handleSuccess(await this.updateRecord());
        }

        await this.refreshItems();
      } catch (e) {
        this.handleUpdateError(e);
      } finally {
        this.closeEditDialog();
        this.overlay = false;
        this.loading = false;
      }
    },

    /**
     * 編集ダイアログのキャンセルまたは戻るボタンクリックイベントを処理する。
     */
    handleCloseEditDialog() {
      this.closeEditDialog();
    },

    /**
     * 編集ダイアログを開く
     */
    openEditDialog() {
      this.dialog = true;

      this.$nextTick(() => {
        // スクロールのリセット
        const elements = document.getElementsByClassName("v-dialog--active");
        if (elements && elements.length > 0) {
          elements[0].scrollTop = 0;
        }

        // バリデーションのリセット
        this.$refs.form.resetValidation();
      });
    },

    /**
     * 編集ダイアログを閉じる
     */
    async closeEditDialog() {
      this.dialog = false;
      this.$refs.form.resetValidation();

      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = createEditedItem();
      });

      // リストボックス用施設名取得
      this.facilities = await fetchVulFacilitiesList(this.screenId);
    },

    /**
     * 登録・更新用のペイロードを作成する。
     */
    preparePayload() {
      // DPND施設IDを除外
      const payload = { ...this.editedItem };
      delete payload.dpnd_fa_id;

      // vul_facility_infoにedited_vul_facility_infoを設定
      payload.vul_facility_info = payload.edited_vul_facility_info;

      // edited_vul_facility_infoを除外
      delete payload.edited_vul_facility_info;

      return payload;
    },

    /**
     * 要配慮者施設マスタを登録する。
     */
    async createRecord() {
      return await vulFacilityRepository.create(
        this.screenId,
        this.preparePayload()
      );
    },

    /**
     * 要配慮者施設マスタを更新する。
     */
    async updateRecord() {
      const { fa_id, hash } = this.items[this.editedIndex];

      return await vulFacilityRepository.update(this.screenId, {
        fa_id,
        hash,
        ...this.preparePayload()
      });
    },

    /**
     * 要配慮者施設マスタを削除する。
     * @param {Object} item 削除するアイテム
     */
    async deleteRecord(item) {
      return await vulFacilityRepository.delete(this.screenId, {
        fa_id: item.fa_id,
        eva_location_type: item.eva_location_type,
        hash: item.hash
      });
    },

    /**
     * 確認ダイアログを表示する。
     * @param {string} buttonText ボタンに表示するテキスト
     * @param {...string} messages メッセージ
     * @returns {boolean} キャンセルされていないかどうかを示す値。
     */
    async showConfirmDialog(buttonText, ...messages) {
      return await this.$refs.confirmDialog.open(messages, buttonText);
    },

    /**
     * 一覧表のページネーションをリセット
     */
    resetPage() {
      this.$refs.table?.resetPage();
    },

    /* calculateDistance()の結果を返す */
    returnDistance() {
      const lat = this.editedItem.latitude;
      const lng = this.editedItem.longitude;

      // 緯度・経度が空でないかつ、0より大きいかをチェック
      if (lat !== "" && lng !== "" && Number(lat) > 0 && Number(lng) > 0) {
        this.editedItem.distance_from_npp = this.calculateDistance(lat, lng);
      } else {
        this.editedItem.distance_from_npp = ""; // 空または0以下ならクリア
      }
    },

    /* calculateBearing()の結果を返す */
    returnDirection() {
      const lat = this.editedItem.latitude;
      const lng = this.editedItem.longitude;

      // 緯度・経度が空でないかつ、0より大きいかをチェック
      if (lat !== "" && lng !== "" && Number(lat) > 0 && Number(lng) > 0) {
        this.editedItem.direction_from_npp = this.calculateBearing(lat, lng);
      } else {
        this.editedItem.direction_from_npp = ""; // 空または0以下ならクリア
      }
    },

    /* 緯度・経度から距離を計算*/
    calculateDistance(latitude, longitude) {
      /* 避難元の緯度、経度 */
      const latitude1 = latitude;
      const longitude1 = longitude;
      /* 原発の緯度、経度 */
      const latitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LAT);
      const longitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LON);

      const diffLatitudeRadian = ((latitude2 - latitude1) * Math.PI) / 180;
      const diffLongitudeRadian = ((longitude2 - longitude1) * Math.PI) / 180;
      const latitudeRadian = (latitude1 * Math.PI) / 180;
      const longitudeRadian = (latitude2 * Math.PI) / 180;
      const a =
        Math.sin(diffLatitudeRadian / 2) * Math.sin(diffLatitudeRadian / 2) +
        Math.sin(diffLongitudeRadian / 2) *
          Math.sin(diffLongitudeRadian / 2) *
          Math.cos(latitudeRadian) *
          Math.cos(longitudeRadian);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const calculateResult = EARTH_RADIUS * c;
      const result = Math.floor(calculateResult * 10) / 10;
      return result;
    },

    /*緯度経度から方角を計算*/
    calculateBearing(latitude, longitude) {
      /* 避難元の緯度、経度 */
      const latitude1 = latitude;
      const longitude1 = longitude;
      /* 原発の緯度、経度 */
      const latitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LAT);
      const longitude2 = Number(process.env.VUE_APP_NUCLEAR_POWER_PLANT_LON);

      /* ラジアンに変換 */
      const toRadians = deg => (deg * Math.PI) / 180;
      const toDegrees = rad => (rad * 180) / Math.PI;

      const diameter1 = toRadians(latitude2);
      const diameter2 = toRadians(latitude1);
      const difference = toRadians(longitude1 - longitude2);

      const y = Math.sin(difference) * Math.cos(diameter2);
      const x =
        Math.cos(diameter1) * Math.sin(diameter2) -
        Math.sin(diameter1) * Math.cos(diameter2) * Math.cos(difference);
      let angle = Math.atan2(y, x);
      angle = (toDegrees(angle) + 360) % 360; // 0〜360度に変換

      return this.bearingToCompass(angle);
    },

    /* 方角を数値から文字列に変換 */
    bearingToCompass(bearing) {
      directions;
      const index = Math.round(bearing / 22.5) % 16;
      return directions[index];
    },

    // 指定した施設種別に属する施設詳細種別のリストを返す
    // detailsTypes: 元となる施設詳細種別リスト
    // faType: 施設種別
    toDetailsTypesByFaType(detailsTypes, faType) {
      if (arrayCount(detailsTypes) > 0) {
        return detailsTypes.filter(
          detailsTypes => detailsTypes.fa_type === faType
        );
      }
      return [];
    },

    /**
     * 避難所名を取得
     */
    getVulFacilityPlaceNames(item) {
      if (!item.vul_facility_info || !Array.isArray(item.vul_facility_info)) {
        return "";
      }
      const facilityNames = item.vul_facility_info
        .filter(facility => facility.vul_origin_fa_name)
        .map(facility => facility.vul_origin_fa_name)
        .filter(name => name);
      return facilityNames.join("<br>");
    }
  }
};
</script>
